import React from 'react'

function TechSelectionRSA() {
  return (
    <embed src="\pdfs\E1.5.8.1_VA-RSA_Displacement_ventilation_for_indoor_firing_ranges_03.2014_Kr.pdf" width="100%" height="2100px" />
  )
}

export default TechSelectionRSA